/*
 * @Author: luting
 * @Date: 2022-08-16 16:34:16
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-03 16:44:17
 */
import React, { useState, useRef } from 'react';
import { Button, Row, Col, message, Progress, Spin } from 'sup-ui';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';

import SetForm from './SetForm';
import CommonModal from 'root/components/CommonModal';
import Icon from 'root/components/Icon';

import messages from '../messages';
import { putServerDataApi, linkServerApi, postServerDataApi, checkNodeStatusApi } from 'root/services/disk';

import styles from './index.less';

interface LinkSetType {
  serverData: any;
  getServerData: () => void;
}

interface CircleType {
  limit: number;
  name: string;
  used: number;
  total: number;
  unit: string;
}

const LinkSet: React.FC<LinkSetType> = (props) => {
  const intl = useIntl();
  const modalServerRef = useRef<any>();
  const {
    serverData: { ip, name, sshPort, cpuInfo = {}, diskInfo = {}, memoryInfo = {}, systemVersion } = {},
    serverData,
    getServerData,
  } = props;
  const { singleNodeId } = useSelector((state: reducerStates) => state.envManage);
  const [visible, setVisible] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [inputValue, setInputValue] = useState<string | undefined>(undefined);
  let loopTimer: any = null;

  const handleOk = () => {
    if (!modalServerRef.current.validateFields) return;

    modalServerRef?.current.validateFields((err: boolean, values: any) => {
      if (err) return;
      setSubmit(true);
      const handleFun = ip ? putServerDataApi : postServerDataApi;
      // 默认密码为defaultPassword
      const { password } = values;
      const { labels } = values;
      const newLabels = labels?.map((item: any) => {
        if (item === 0) return inputValue;
        return item;
      });

      const params = {
        ...values,
        id: singleNodeId,
        password: password === 'defaultPassword' ? '' : password,
        labels: newLabels || [],
      };

      handleFun(params)
        .then(() => {
          // 刷新数据
          checkNodeUseabled(singleNodeId || '');
        })
        .catch(() => {
          setSubmit(false);
        });
    });
  };

  // 论询
  const loopGetData = (id: string) => {
    loopTimer = setTimeout(() => {
      clearTimeout(loopTimer);
      checkNodeUseabled(id);
    }, 1000 * 3);
  };

  const checkNodeUseabled = (id: string) => {
    // 检查到有节点才跳转
    checkNodeStatusApi({ serverNodeId: id })
      .then((res: any) => {
        const { data } = res;
        if (data) {
          setSubmit(false);
          getServerData();
          setVisible(false);
          message.success(intl.formatMessage(messages.setSuccess));
        } else {
          loopGetData(id);
        }
      })
      .catch(() => {
        setSubmit(false);
      });
  };

  const hanldeTestLink = () => {
    setBtnLoading(true);
    linkServerApi(singleNodeId as string)
      .then((res: any) => {
        const {
          data: { connected, cause },
        } = res;
        if (connected) {
          message.success(intl.formatMessage(messages.testLinkSuccess));
          return;
        }
        message.error(cause);
      })
      .finally(() => {
        setBtnLoading(false);
      });
  };

  const renderCircular = (data: CircleType) => {
    const { limit = 0, name = '-', used = 0, total = 0, unit = '-' } = data;
    // limit  = total * 外部的告警最大值
    const usedNum = Number(used);
    const limitNum = Number(limit);
    const totalNum = Number(total);
    return (
      <div className={styles.circularBox}>
        <div className={styles.circular}>
          <div className={styles.base} />
          <Progress
            strokeColor={usedNum > limitNum ? '#FF0036' : '#00FFC9'}
            width={28}
            strokeLinecap="square"
            className={usedNum > limitNum ? styles.circleOverColor : styles.circleColor}
            strokeWidth={20}
            showInfo={false}
            type="circle"
            percent={(usedNum / totalNum) * 100}
          />
        </div>
        <div>
          {name}
          <div>
            <span>{used}</span> /{' '}
            <span>
              {total} {unit}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.link_set}>
      <div className={styles.link_set_head}>
        <div className={styles.title}>
          <Icon type="host20" style={{ fontSize: 20 }} />
          <span>{name}</span>
          <Icon type="edits" style={{ fontSize: 16 }} onClick={() => setVisible(true)} />
          <span className={styles.operatingSystem}>
            {intl.formatMessage(messages.operatingSystem)} : {systemVersion}
          </span>
          {systemVersion?.startsWith('Ubuntu 16.04') ? (
            <span className={styles.approach}>{intl.formatMessage(messages.approach)}</span>
          ) : null}
        </div>
        <div className={styles.btnGroup}>
          <Button loading={btnLoading} onClick={hanldeTestLink}>
            {intl.formatMessage(messages.testLink)}
          </Button>
          <Button onClick={() => setVisible(true)}>{intl.formatMessage(messages.set)}</Button>
        </div>
      </div>

      <Row className={styles.link_set_content}>
        <Col span={5}>
          <span>{intl.formatMessage(messages.serverAddress)}</span>
          <div>{ip || '-'}</div>
        </Col>
        <Col span={4}>
          <span>{intl.formatMessage(messages.sshPort)}</span>
          <div>{sshPort || '-'}</div>
        </Col>

        <Col span={5}>
          {renderCircular({
            name: 'CPU',
            limit: cpuInfo?.limit,
            used: cpuInfo?.used,
            total: cpuInfo?.total,
            unit: cpuInfo?.unit,
          })}
        </Col>

        <Col span={5}>
          {renderCircular({
            name: intl.formatMessage(messages.memory),
            limit: memoryInfo?.limit,
            used: memoryInfo?.used,
            total: memoryInfo?.total,
            unit: memoryInfo?.unit,
          })}
        </Col>

        <Col span={5}>
          {renderCircular({
            name: intl.formatMessage(messages.diskInfo),
            limit: diskInfo?.limit,
            used: diskInfo?.used,
            total: diskInfo?.total,
            unit: diskInfo?.unit,
          })}
        </Col>
      </Row>

      <CommonModal
        visible={visible}
        title={intl.formatMessage(messages.set)}
        onCancel={() => {
          !submit && setVisible(false);
        }}
        height="auto"
        destroyOnClose
        closable={false}
        footer={[
          <Button type="primary" key="ok" onClick={handleOk} disabled={submit}>
            {intl.formatMessage(messages.sure)}
          </Button>,
          <Button onClick={() => setVisible(false)} disabled={submit} key="cancel">
            {intl.formatMessage(messages.cancel)}
          </Button>,
        ]}
      >
        <Spin spinning={submit}>
          <SetForm inputValue={inputValue} setInputValue={setInputValue} ref={modalServerRef} data={serverData} />
        </Spin>
      </CommonModal>
    </div>
  );
};

export default LinkSet;
